module.exports = __webpack_public_path__ + "pc/img/brand03.e7a5ebb5.png";